import { cn } from "@/lib/utils";

/** Figma auth page palette */
export const LOGIN_COLORS = {
  teal: "#4DB6AC",
  tealHover: "#45a89e",
  tealDark: "#006064",
  mintBg: "#F0FDF4",
  cardBg: "#F1F5F9",
  textMuted: "#6B7280",
  textBody: "#374151",
  textHeading: "#111827",
  inputBorder: "#E5E7EB",
} as const;

export type AuthFormAppearance = "default" | "authPage";

export type AuthFlowView =
  | "phone"
  | "password"
  | "register"
  | "set-password"
  | "enter-otp"
  | "reset-password";

export function loginInputClass(appearance: AuthFormAppearance): string {
  if (appearance !== "authPage") return "";
  return cn(
    "rounded-xl border-[#E5E7EB] bg-white shadow-none",
    "focus-visible:border-[#4DB6AC] focus-visible:ring-2 focus-visible:ring-[#4DB6AC]/20",
  );
}

export function loginPhoneInputClass(appearance: AuthFormAppearance): string {
  if (appearance !== "authPage") return "";
  return cn(
    "h-12 text-base !rounded-xl !border-[#E5E7EB] bg-white !shadow-none",
    "[&>input]:text-base ",
  );
}

export function loginPhoneBannerClass(appearance: AuthFormAppearance): string {
  if (appearance !== "authPage") {
    return "rounded-xl bg-primary/5 text-primary";
  }
  return "rounded-xl border border-[#E5E7EB] bg-white px-4 py-3 text-[#374151]";
}

export function loginFormLabelClass(appearance: AuthFormAppearance): string {
  if (appearance !== "authPage") return "";
  return "text-sm font-medium text-[#374151]";
}

export function loginSubmitClass(
  appearance: AuthFormAppearance,
  variant: "primary" | "continue" = "primary",
): string {
  const height =
    appearance === "authPage" || variant === "continue" ? "h-12" : "h-14";
  const base = cn("w-full rounded-xl font-bold text-base shadow-none", height);

  if (appearance === "authPage") {
    return cn(
      base,
      "bg-success text-white hover:bg-success/90 active:bg-success/80",
    );
  }

  return cn(base, variant === "continue" ? "" : "");
}
